<template>
    <el-container class="login" id="login" v-bind:style="{height:heightB+'px'}">
        <!--<Header></Header>-->
        <el-main>
            <el-row :gutter="10">
                <el-col :span="7"><div>&nbsp;</div></el-col>
                <el-col :span="10">
                    <div class="logo">
                        <!--<img src="../assets/gy_logo.png" width="75px">-->
                        <i class="fa fa-stethoscope" aria-hidden="true"></i>
                    </div>
                    <h1>广元市第四人民医院</h1>
                </el-col>
                <el-col :span="7">
                    <div class="phone">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        <span>+86 0839-3451422</span>
                    </div>
                </el-col>
            </el-row>
            <el-carousel trigger="click" height="408px">
                <el-carousel-item v-for="item in banner" :key="item.i" class="agileits-banner-info">
                    <div></div>
                    <h3>{{item.h3}}</h3>
                    <p>{{item.p}}</p>
                </el-carousel-item>
            </el-carousel>
        </el-main>
        <el-footer class="login-footer" style="height:none;position: relative">
            <h4>登录患者门户平台</h4>
            <div class="login-form">
                <el-row :gutter="20">
                    <el-col :span="20">
                        <el-row :gutter="5">
                            <el-col :span="6"><el-input v-model="form.name" placeholder="姓名"></el-input></el-col>
                            <el-col :span="6"><el-input v-model="form.id" placeholder="身份证号码"></el-input></el-col>
                            <el-col :span="7">
                                <el-input v-model="form.phone" placeholder="手机号码">
                                    <el-button slot="append" v-if="countDown <= 0" @click="checkEmpiUser" style="color:#409eff">发送验证码</el-button>
                                    <el-button slot="append" v-if="countDown > 0">{{countDown}}s</el-button>
                                </el-input>
                            </el-col>
                            <el-col :span="5"><el-input v-model="form.verificationCode" placeholder="验证码"></el-input></el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="4">
                        <el-button type="primary" style="width:100%;" class="login_button" @click="loginSubmit">登录</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-footer>

        <QrCode></QrCode>
    </el-container>
</template>

<script>
  import Header from './components/Header.vue'
import QrCode from './components/qr-code.vue'
import {sendMessageCode} from '@/api/messageApi.js'
import {getEmpiUser} from '@/api/empiApi.js'
import {randomNum} from '@/api/helper/index.js'
let moment = require("moment");
import axios from 'axios'

export default {
    name: 'Login',
    components:{QrCode,Header},
    data(){
        return {
            heightB:document.documentElement.clientHeight,
            banner:[
                {
                    i:0,
                    h3:'Best Treatments',
                    p:'We Provide the Best Medical Services.'
                },
                {
                    i:1,
                    h3:'We Provide',
                    p:'Medical Services that you can Trust.'
                },
                {
                    i:2,
                    h3:'Better Technology',
                    p:'We Care About Your Health.'
                }
            ],
            form:{
                name:'',
                id:'',
                phone:'',
                verificationCode:''
            },
            countDown:0,
        }
    },
    mounted(){
        this.resizeTable()
        window.addEventListener('resize',() => this.resizeTable(), false);
    },
    methods:{
        resizeTable(){
            this.heightB = document.documentElement.clientHeight;
            //this.widthB  = this.heightB*1.86;
        },
        checkEmpiUser(){
            if(!this.form.name){
                this.$message({message: '请输入您的姓名', type: 'warning'});return false;
            }
            if(!this.form.id){
                this.$message({message: '请输入您的身份证号', type: 'warning'});return false;
            }
            if(!this.form.phone){
                this.$message({message: '请输入您预留的手机号码', type: 'warning'});return false;
            }
            if(this.form.phone.length != 11){
                this.$message({message: '手机号码长度为11位', type: 'warning'});return false;
            }
            getEmpiUser({
                page:0,
                size:10,
                specification:JSON.stringify({
                    XM:this.form.name,
                    SFZHM:this.form.id
                })
            }).then(res=>{
                let title = '';
                if(res && res.list.length > 0){
                    if(res.list[0].XM == this.form.name && res.list[0].SFZHM == this.form.id){
                        if(res.list[0].SJHM == this.form.phone){
                            this.$cookies.set('CHECK_EMPI', JSON.stringify({
                                mdmId:res.list[0].mdmId ? res.list[0].mdmId : '',
                                esId:res.list[0].esId ? res.list[0].esId : '',
                                xm:res.list[0].XM ? res.list[0].XM : '',
                                csd:res.list[0].CSD ? res.list[0].CSD : '',
                                lxr:res.list[0].LXRXM ? res.list[0].LXRXM : '',
                                lxrdh:res.list[0].LXRDH ? res.list[0].LXRDH : '',
                            }),{expires:1})
                            this.sendVerification(this.form.phone)
                        }else{
                            title = '您的预留手机号码信息有误，请至医院柜台补全信息后登陆'
                        }
                    }else{
                        title = '您的信息有误，请至医院柜台补全信息后登陆'
                    }
                }else{
                    title = '未查询到您的就医信息'
                }
                if(title){
                    this.$alert(title, '提示', {
                        confirmButtonText: '确定',
                        callback: action => {}
                    });
                }
            }).catch(err=>{
                this.$message.error('验证失败，请稍后再试')
            })
        },
        sendVerification(phone){
            let code = randomNum(false,5)
            let time  = moment(new Date()).format('YYYYMMDDhmmss')+code
            this.makeVerification(phone,code,time)
            let xml = '<?xml version="1.0" encoding="UTF-8"?><message><key>8CEB6493-E499-D0E5-2015-7D19AE999FBD</key><msgContent>&lt;?xml version="1.0" encoding="UTF-8"?&gt;&lt;!--调用时间 '+time+'--&gt;&lt;json&gt;{"funcode":"100122","args":{"phone":"'+phone+'","tcontent":"【广元市精神卫生中心】您当前正在使用患者门户平台，登录验证码是：'+code+'，如非本人操作，请忽略此短信。"}}&lt;/json&gt;</msgContent> <msgCode>SendMessage</msgCode><msgVersion>1</msgVersion></message>';
            var config = {
                headers: {'Content-Type': 'application/xml'}
            };
            axios.post('/hie_api/hie/services/hieService/msgTransfer', xml, config).then(res=>{
                if(res.data.errorCode || res.data.errorInfo){
                    this.$message.error(res.data.errorInfo)
                }else{
                    let result = res.data.syncResult ? JSON.parse(res.data.syncResult) : '';
                    if(result && result.code == 0){
                        this.countDown = 60
                        var m = setInterval(()=>{
                            this.countDown--;
                            if(this.countDown==0){
                                clearInterval(m);
                                this.countDown = 0;
                            }
                        },1000);
                        this.$message({message:'短信发送成功',type:'success'});
                    }else{
                        this.$message.error('验证码发送失败，请稍后再试')
                    }
                }
            }).catch(err=>{
                this.$message.error('验证码发送失败，请稍后再试')
            })
        },
        makeVerification(phone,code,time){
            //将数据组合成对象，放入到cookie中，验证时判断手机号合时间参数
            this.$cookies.set('LOGIN_VERIFICATION', JSON.stringify({
                phone:phone,
                code:code,
                time:time
            }),{expires:1})
        },
        loginSubmit(){
            if(!this.form.name){
                this.$message({message: '请输入您的姓名', type: 'warning'});return false;
            }
            if(!this.form.id){
                this.$message({message: '请输入您的身份证号', type: 'warning'});return false;
            }
            if(!this.form.phone){
                this.$message({message: '请输入您预留的手机号码', type: 'warning'});return false;
            }
            if(this.form.phone.length != 11){
                this.$message({message: '手机号码长度为11位', type: 'warning'});return false;
            }
            if(!this.form.verificationCode || this.form.verificationCode.length != 5){
                this.$message({message: '请输入5位手机短信验证码', type: 'warning'});return false;
            }
            let verification = this.$cookies.get('LOGIN_VERIFICATION')
            if(!verification || !verification.phone || !verification.code){
                this.$message({message: '验证码验证失败', type: 'warning'});return false;
            }
            if(this.form.phone != verification.phone || this.form.verificationCode != verification.code ){
                this.$message({message: '验证码不匹配', type: 'warning'});return false;
            }
            let empi = this.$cookies.get('CHECK_EMPI')
            this.$cookies.set('LOGIN_INFO', JSON.stringify({
                mdmId:empi.mdmId,
                esId:empi.esId,
                xm:empi.xm,
                csd:empi.csd,
                lxr:empi.lxr,
                lxrdh:empi.lxrdh,
            }),{expires:1})
            this.$cookies.remove('CHECK_EMPI')
            this.$cookies.remove('LOGIN_VERIFICATION')
            this.$router.push({ name: 'jyjl'})
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/login.vue